import { cn } from "../../lib/cn";

/**
 * Phase 2 primitive — `<Timeline>` is a vertical list of dated events
 * with a connecting rail + coloured dots. Phase 4 will consume this for
 * the Scoping drawer's `.kb-history` section and Phase 3c for the audit
 * drawer's `.aud-tl-*` timeline.
 *
 * Shape:
 *   items = [{ title, meta, body?, tone?: 'default'|'active'|'done'|'warn'|'crit' }, ...]
 */
const DOT_TONE = {
  default: "bg-rc-border border-rc-blue-400",
  active:  "bg-rc-accent border-rc-accent-strong",
  done:    "bg-[#10c981] border-[#10c981]",
  warn:    "bg-[#f59e0b] border-[#f59e0b]",
  crit:    "bg-rc-red border-rc-red",
};

export default function Timeline({ items, className }) {
  const rows = Array.isArray(items) ? items : [];
  return (
    <ol className={cn("relative pl-6 border-l border-rc-border space-y-4", className)}>
      {rows.map((item, i) => (
        <li key={i} className="relative">
          <span
            aria-hidden
            className={cn(
              "absolute -left-[31px] top-1 w-3 h-3 rounded-full border-2",
              DOT_TONE[item.tone] || DOT_TONE.default,
            )}
          />
          <div className="flex items-baseline justify-between gap-3 flex-wrap">
            <div className="text-[13px] font-semibold text-rc-text-primary">{item.title}</div>
            {item.meta && (
              <div className="font-mono text-[10.5px] text-rc-text-dim">{item.meta}</div>
            )}
          </div>
          {item.body && (
            <div className="mt-1 text-xs text-rc-text-secondary leading-[1.55]">
              {item.body}
            </div>
          )}
        </li>
      ))}
    </ol>
  );
}
